import type { FaireProductEntity } from "../../entity_types/product";

export const p_fndrqytean: FaireProductEntity = {
  token: "p_fndrqytean",
  type: "product",
  name: "Celestine 18K Gold Non-Tarnish Evil Eye Chain Bracelet",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/f11cb8c852cbf9e13811823778a1a6bc5cf9dd948ffc3f5215d35837700cb6ff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de2c89a9e801c397db2126a1ef2bd1cf70645e02f9f100c262395de707f2d5f5.jpeg",
    "https://cdn.faire.com/fastly/771a2e381541d24d7db970ec6ebd4ba002d45f2883d307b97fc25b051ad6baff.jpeg",
    "https://cdn.faire.com/fastly/b6d2a8f153dc0c40bd92467d92ab6642a17884bfd12f20821af5dcad23b96940.jpeg",
  ],
  priceDollars: 9.64,
  description:
    "18K Gold Non-Tarnish Evil Eye Chain Bracelet\n18K Gold Plating\nStainless Steel\nPendant Size (inch): 0.4\nChain Length (inch): 6.5\nExtension Length (inch): 1.97\n\n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:08.313Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
